export default __webpack_public_path__ + "static/media/Sweep the Backstreets.fb5398ef.png";